/**
 * PlantApi
 * 1.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type InspCategoryDto = {
    code: string;
    description: string;
    rank: number;
};
export type DataStatus = "success" | "notValid" | "exception" | "error" | "inUse" | "notFound" | "noChange" | "inProgress" | "invalidPage" | "notAuthorized" | "duplicateEntity" | "noContent" | "accepted";
export type ErrorResponse = {
    message: string;
    kind: DataStatus;
    exception?: string | null;
    stackTrace?: string | null;
    exceptionType?: string | null;
    innerException?: string | null;
    validationErrors?: {
        [key: string]: string[];
    } | null;
};
export type ValidationProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors: {
        [key: string]: string[];
    };
    [key: string]: any;
};
export type InspectionTypeDto = {
    "number": number;
    name: string;
    maxScore?: number | null;
    minScore?: number | null;
    lastInspector: string;
    comments: string;
    active: boolean;
    isScoreRange: boolean;
    isNumericScore: boolean;
    corporateReporting: string;
    overallForMax: number;
    autoScore: boolean;
    inspStartScore?: number | null;
};
export type InspectionDetailDto = {
    seq: number;
    description: string;
    equipRangeStart?: number | null;
    equipRangeEnd?: number | null;
    isWholePlant: boolean;
};
export type InspectionSpecificScoreDto = {
    score: number;
    description: string;
};
export type InspectionTakeAwayPointsDto = {
    description: string;
    score: number;
};
export type InspectionOverallObservationDto = {
    seq: number;
    description: string;
    isRequiredForMaxScore: boolean;
};
export type InspectionDocumentDto = {
    inspectionInformation: InspectionTypeDto;
    detailPointList: InspectionDetailDto[];
    specificScoreList: InspectionSpecificScoreDto[];
    takeAwayPointsList: InspectionTakeAwayPointsDto[];
    overallObservationList: InspectionOverallObservationDto[];
};
export type InspectionTypeViewDto = {
    "number": number;
    name: string;
    maxScore?: number | null;
    minScore?: number | null;
    lastInspector: string;
    comments: string;
    active: boolean;
    isScoreRange: boolean;
    isNumericScore: boolean;
    corporateReporting: string;
    overallForMax: number;
    autoScore: boolean;
    inspStartScore?: number | null;
};
export type InspectionDetailViewDto = {
    seq: number;
    description: string;
    equipRangeStart?: number | null;
    equipRangeStartName: string;
    equipRangeEnd?: number | null;
    equipRangeEndName: string;
    isWholePlant: boolean;
};
export type InspectionDocumentViewDto = {
    inspectionInformation: InspectionTypeViewDto;
    detailPointList: InspectionDetailViewDto[];
    specificScoreList: InspectionSpecificScoreDto[];
    takeAwayPointsList: InspectionTakeAwayPointsDto[];
    overallObservationList: InspectionOverallObservationDto[];
};
export type InspZoneDto = {
    "number": number;
    description: string;
    rank: number;
    "default": boolean;
    active: boolean;
    allowEdit: boolean;
};
export function getInspectionCategoryList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspCategoryDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/inspcategory", {
        ...opts
    });
}
/**
 * Inspection Category Code is provided by the End User. It is not auto generated. 409 error on attempted duplicate.
 */
export function createInspectionCategory(inspCategoryDto: InspCategoryDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspCategoryDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/inspcategory", oazapfts.json({
        ...opts,
        method: "POST",
        body: inspCategoryDto
    }));
}
export function getInspectionCategory(code: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspCategoryDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspcategory/${encodeURIComponent(code)}`, {
        ...opts
    });
}
export function updateInspectionCategory(code: string, inspCategoryDto: InspCategoryDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspCategoryDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspcategory/${encodeURIComponent(code)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: inspCategoryDto
    }));
}
export function deleteInspectionCategory(code: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspcategory/${encodeURIComponent(code)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List of the Inspections (not whole documents).
 */
export function getInspectionList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspectionTypeDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/inspection", {
        ...opts
    });
}
/**
 * Inspection Numbers are assigned automatically at the time of a successful create.
 */
export function createInspection(inspectionDocumentDto: InspectionDocumentDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspectionDocumentViewDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/inspection", oazapfts.json({
        ...opts,
        method: "POST",
        body: inspectionDocumentDto
    }));
}
export function getInspection($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspectionDocumentViewDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspection/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateInspection($number: number, inspectionDocumentDto: InspectionDocumentDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspectionDocumentViewDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspection/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: inspectionDocumentDto
    }));
}
export function deleteInspection($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspection/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function getInspectionZoneList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspZoneDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/inspzone", {
        ...opts
    });
}
/**
 * Inspection Zone Number is provided by the End User. It is not auto generated. 409 error on attempted duplicate.
 */
export function createInspectionZone(inspZoneDto: InspZoneDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspZoneDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/inspzone", oazapfts.json({
        ...opts,
        method: "POST",
        body: inspZoneDto
    }));
}
export function getInspectionZone($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspZoneDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspzone/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateInspectionZone($number: number, inspZoneDto: InspZoneDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InspZoneDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspzone/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: inspZoneDto
    }));
}
export function deleteInspectionZone($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/inspzone/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
